import React, { useState, useEffect } from "react";
import { Box, Checkbox, Typography } from "@mui/material";
import Button from "../../components/inputs/Button";
import Textfield from "../../components/inputs/Textfield";

const Home = ({ setState, mobile }) => {
  return (
    <>
      <Typography
        style={{
          fontWeight: "bold",
          fontSize: mobile ? "42px" : "60px",
          color: "white",
          textAlign: "center",
          lineHeight: "1.2",
          marginTop: "20px",
        }}
      >
        Bienvenido a Full Pass
      </Typography>
      <Typography
        style={{
          fontWeight: "400",
          fontSize: mobile ? "18px" : "20px",
          color: "white",
          textAlign: "center",
        }}
      >
        Accedé a tus gimnasios favoritos con una única suscripción.
      </Typography>
      <Button sx={{ marginTop: mobile ? "10px" : "30px" }} onClick={() => (setState ? setState(2) : undefined)}>
        Registrarse
      </Button>
      <Button stroked={true} onClick={() => (setState ? setState(1) : undefined)}>
        Iniciar sesión
      </Button>
    </>
  );
};

export default Home;
